export class GmsAccessGrant {
    grantedToUsername: string;
    gmsIds: string[];
    sendMail: boolean;
}